import useLocalization from 'src/services/localization/useLocalization';
import useClipboard from 'src/utils/js-helpers/useClipboard';
import { styles } from './BigProductCardShareDropdown.styles';

export interface BigProductCardShareDropdownProps {
  onItemClick(): void;
  onShowMessage(translationKey: string): void;
  productName: string;
}

export default function BigProductCardShareDropdown(
  props: BigProductCardShareDropdownProps,
) {
  const { onItemClick, productName, onShowMessage } = props;

  const { copyToClipboard } = useClipboard();
  const localize = useLocalization();

  const handleItemClick = (href: string) => {
    window.open(href, '_blank');
    onItemClick();
  };

  const productUrl = window.location.href;
  const utmLink = `${productUrl}?utm_source=share&utm_medium=button&utm_campaign=product_share`;

  const shareOptions = [
    {
      name: 'Facebook',
      img: '/i/sharingPopup/facebook.svg',
      href: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(utmLink)}`,
      dataMarker: 'share_on_facebook',
    },
    {
      name: 'Email',
      img: '/i/sharingPopup/email.svg',
      href: `mailto:?subject=${encodeURIComponent(productName)}&body=${encodeURIComponent(utmLink)}`,
      dataMarker: 'share_on_email',
    },
    {
      name: localize('copy_link'),
      img: '/i/sharingPopup/copy.svg',
      dataMarker: 'share_on_copy_link',
      onClick: () => {
        copyToClipboard(utmLink);
        onItemClick();
        onShowMessage('link_copied');
      },
    },
  ];

  return (
    <div
      role='menu'
      aria-label='Share options'
      className='BigProductCardShareDropdown'
    >
      <ul className='BigProductCardShareDropdown__list'>
        {shareOptions.map((item) => (
          <li
            key={item.name}
            className='BigProductCardShareDropdown__item'
            role='menuitem'
            aria-label={`Share on ${item.name}`}
            data-marker={item.dataMarker}
            onClick={item.onClick || (() => handleItemClick(item.href))}
          >
            <img
              src={item.img}
              alt={item.name}
              className='BigProductCardShareDropdown__ItemImage'
            />
            {item.name}
          </li>
        ))}
      </ul>

      <style jsx>{styles}</style>
    </div>
  );
}
